import { AlertTriangle, TrendingDown, TrendingUp } from "lucide-react";
import { SALARY_TAB } from "@/constants/testIds";

const PERIOD_LABELS = { mensual: "mensual", quincenal: "por quincena", semanal: "por semana" };

const money = (n) => `$${(n ?? 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

function Column({ label, data, periodLabel }) {
  if (!data) {
    return (
      <div className="flex-1 min-w-[130px]">
        <p className="text-xs text-charcoal/50 mb-1">{label}</p>
        <p className="text-sm text-charcoal/40">Sin salario previo registrado</p>
      </div>
    );
  }
  return (
    <div className="flex-1 min-w-[130px]">
      <p className="text-xs text-charcoal/50 mb-1">{label}</p>
      <p className="text-xs text-charcoal/60">Bruto {periodLabel}: <span className="font-semibold text-charcoal">{money(data.gross_period)}</span></p>
      <p className="text-xs text-charcoal/60">ISR estimado: <span className="font-semibold text-terracotta">-{money(data.isr_a_cargo_period)}</span></p>
      <p className="text-sm text-charcoal">Neto estimado: <span className="font-bold">{money(data.net_period)}</span></p>
      {data.periodicidad !== "mensual" && (
        <p className="text-[11px] text-charcoal/40 mt-0.5">Equivalente mensual neto: {money(data.net_mensual_equivalente)}</p>
      )}
    </div>
  );
}

export function IsrEstimateCard({ estimate, testId }) {
  if (!estimate) return null;
  const periodLabel = PERIOD_LABELS[estimate.periodicidad_pago] || "mensual";
  return (
    <div data-testid={testId || SALARY_TAB.isrPreviewCard} className="bg-petroleum/5 border border-petroleum/20 rounded-lg p-3 space-y-2">
      <p className="text-xs font-semibold text-petroleum uppercase tracking-wide">Estimado de ISR ({periodLabel})</p>
      <div className="flex flex-wrap gap-4">
        <Column label="Antes" data={estimate.before} periodLabel={periodLabel} />
        <Column label="Después" data={estimate.after} periodLabel={periodLabel} />
      </div>

      {estimate.alert_net_not_improving && (
        <div data-testid={SALARY_TAB.isrAlert} className="bg-red-50 border border-red-300 rounded-lg p-2.5 flex items-start gap-2">
          <TrendingDown className="w-4 h-4 text-red-600 shrink-0 mt-0.5" />
          <p className="text-xs text-red-800">
            El salario neto estimado no mejora (o baja) a pesar del aumento en el bruto. Esto puede ocurrir al cruzar el
            límite de ingreso del Subsidio para el Empleo. Revisa el monto con tu contador antes de aplicar el cambio.
          </p>
        </div>
      )}

      <p data-testid={SALARY_TAB.isrDisclaimer} className="text-[11px] text-charcoal/50 pt-1 border-t border-petroleum/10">
        {estimate.disclaimer}
      </p>
    </div>
  );
}
